import { createContext } from 'react';

import { BENEFICIARY_OWNER } from 'modules/Inquiry/Form/formFields';

export const BeneficiaryOwnersContext = createContext({
  fieldName: `${BENEFICIARY_OWNER}[0]`,
  userIndex: 0,
});
